import React from 'react';

function ArrowSmallLeftIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#374957"
        d="M19 11H9l3.293-3.293-1.414-1.414-4.293 4.293a2 2 0 000 2.828l4.293 4.293 1.414-1.414L9 13h10v-2z"
      ></path>
    </svg>
  );
}

export default ArrowSmallLeftIcon;
